import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { UserInfoWithIdT } from 'business/definitions';

/**
 * Hook React Query to fetch the list of possible recipients for a given dashboard
 * @param {number} dashboard_id - The id of the dashboard for which the possible recipients are fetched
 */
export const useGetPossibleRecipients = <T = UserInfoWithIdT[]>(
    dashboard_key?: number,
    selector?: (data: UserInfoWithIdT[]) => T,
): UseQueryResult<T, unknown> =>
    useQuery<UserInfoWithIdT[], unknown, T>({
        queryKey: ['alert/possible_recipients', dashboard_key],

        queryFn: async (): Promise<UserInfoWithIdT[]> => {
            if (!dashboard_key) return [];
            const response = await RQAPICallWithData<UserInfoWithIdT[]>({
                endpoint: `alert/possible_recipients/${dashboard_key}`,
                method: 'GET',
            });
            return response.content.data;
        },

        select: selector,
    });
